import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/Login'
import menu from './menu'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/navmenu',
      name: 'navmenu',
      component: () => import('../components/menu/NavMenu'),
      meta: { requiresAuth: true },
      children: menu
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!sessionStorage.token) {
      next('/login')
    } else if (to.matched.some(record => record.meta.type0 || record.meta.type1)) {
      if (localStorage[`$_${Vue.prototype.getDomain()}type`] === '2') {
        next('/login')
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
